export class WizardNavigation
{
    index: number = 0;
    pages: number = 0;
    finalIndex: number = 0;
    isComplete: boolean = false;
    isBusy: boolean = false;
    isValid: boolean = true;
    
    onComplete: Function;

    constructor( pages: number, onComplete: Function )
    {
        this.pages = pages;
        this.finalIndex = pages - 2; // '2' because the last page is a confirmation page
        this.onComplete = onComplete;
    }

    /**
     * Moves back through the wizard pages
     * @returns 
     */
    back()
    {
        if( this.index == 0 ) return;
        this.index--;
    }

    /**
     * Moves forwards through the wizard pages, and triggers the onComplete function
     * @returns 
     */
    next()
    {
        if( this.index == this.pages - 1 ) return;
        if( this.index == this.finalIndex )
        {
            this.isBusy = true;
            this.onComplete.call( this, () => this.finalize() );
            return;
        }
        this.index++;
    }

    /**
     * Finalizes the wizard and puts it into the confirmation step
     */
    finalize()
    {
        this.isComplete = true;
        this.isBusy = false;
        this.index++;
    };

}